/**
 * CellDocLink.jsx - a number in a table cell that opens its attached file.
 * Row clicks open the detail panel, so the link stops propagation.
 */
import { previewAttachment } from '../../utils/attachmentPreview';
import { docFileName } from '../../hooks/useDocIndex';
import { useApiBase } from '../../context/DataScope';

/* Number that opens its labeled file from a table cell. Row clicks open the
   detail panel, so the link stops propagation. Plain text when no file. */
function CellDocLink({ attId, text }) {
  const base = useApiBase(); // KSA files stream from the KSA Doc Hub
  if (!attId) return <>{text}</>;
  return (
    <button
      type="button"
      // Names the exact file: several can share one number, and this is how
      // you can tell from the table which one it opens.
      title={docFileName(attId) ? `Opens ${docFileName(attId)}` : 'Open the attached file'}
      onClick={(e) => {
        e.stopPropagation();
        previewAttachment(attId, base);
      }}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        font: 'inherit',
        color: '#1565C0',
        fontWeight: 700,
        textDecoration: 'underline',
        textUnderlineOffset: 2,
      }}
    >
      {text}
    </button>
  );
}
export default CellDocLink;
